import { Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../_services/spinner.service';
import * as i0 from "@angular/core";
var LoadingSpinnerInterceptorService = /** @class */ (function () {
    function LoadingSpinnerInterceptorService(injector) {
        this.injector = injector;
        this.numRequests = 0;
        this.spinnerService = this.injector.get(SpinnerService);
    }
    LoadingSpinnerInterceptorService.prototype.intercept = function (req, next) {
        this.turnOnModal();
        var that = this;
        return next.handle(req).pipe(finalize(function () { that.turnOffModal(); }));
    };
    ;
    LoadingSpinnerInterceptorService.prototype.turnOnModal = function () {
        this.numRequests++;
        if (!this.showLoading) {
            this.showLoading = true;
            this.spinnerService.block();
        }
    };
    LoadingSpinnerInterceptorService.prototype.turnOffModal = function () {
        this.numRequests--;
        if (this.numRequests <= 0 && this.showLoading) {
            this.showLoading = false;
            this.spinnerService.unblock();
        }
    };
    LoadingSpinnerInterceptorService.ngInjectableDef = i0.defineInjectable({ factory: function LoadingSpinnerInterceptorService_Factory() { return new LoadingSpinnerInterceptorService(i0.inject(i0.INJECTOR)); }, token: LoadingSpinnerInterceptorService, providedIn: "root" });
    return LoadingSpinnerInterceptorService;
}());
export { LoadingSpinnerInterceptorService };
